export default "__VITE_PUBLIC_ASSET__1dbbf153__"